import { c as _c } from "react/compiler-runtime";
import { useQueries } from '@tanstack/react-query';
import { useIsAuthenticated } from '../context/UserContext';
import { type WrappedTRPCClient } from '../helpers/trpcClientTypes';
const ROLE_DEFAULT = {
  isAdmin: false,
  isModerator: false
};
const useRole = client => {
  const $ = _c(24);
  const enabled = useIsAuthenticated() === true;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["users", "role"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== client) {
    t1 = async () => {
      const [, d] = await client.users.role.query();
      return d ?? ROLE_DEFAULT;
    };
    $[1] = client;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== enabled || $[4] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      enabled,
      staleTime: Infinity
    };
    $[3] = enabled;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["users", "premium"];
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== client) {
    t4 = async () => {
      const [, d_0] = await client.users.premium.query();
      return {
        premiumExpires: d_0?.premiumExpires ?? null,
        isFounder: d_0?.isFounder ?? false
      };
    };
    $[7] = client;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== enabled || $[10] !== t4) {
    t5 = {
      queryKey: t3,
      queryFn: t4,
      enabled,
      staleTime: Infinity
    };
    $[9] = enabled;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t2 || $[13] !== t5) {
    t6 = {
      queries: [t2, t5]
    };
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const [role, premium] = useQueries(t6);
  const t7 = role.isLoading || premium.isLoading;
  const t8 = role.data?.isAdmin ?? false;
  const t9 = role.data?.isModerator ?? false;
  const t10 = premium.data?.premiumExpires ?? null;
  let t11;
  if ($[15] !== premium.data) {
    t11 = premium.data?.premiumExpires && new Date(premium.data.premiumExpires) > new Date();
    $[15] = premium.data;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const t12 = Boolean(t11);
  const t13 = premium.data?.isFounder ?? false;
  let t14;
  if ($[17] !== t10 || $[18] !== t12 || $[19] !== t13 || $[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t14 = {
      isLoading: t7,
      isAdmin: t8,
      isModerator: t9,
      premiumExpires: t10,
      isPremium: t12,
      isFounder: t13
    };
    $[17] = t10;
    $[18] = t12;
    $[19] = t13;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  return t14;
};
export default useRole;